// Google Consent Mode v2 helpers.
// All consent state is persisted in localStorage and forwarded to gtag + dataLayer.

export const CONSENT_STORAGE_KEY = "arqovena_consent_v1";

export const DEFAULT_DENIED_STATE = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "granted",
  personalization_storage: "denied",
  security_storage: "granted",
};

export const ALL_GRANTED_STATE = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
  functionality_storage: "granted",
  personalization_storage: "granted",
  security_storage: "granted",
};

export const ALL_DENIED_STATE = { ...DEFAULT_DENIED_STATE };

function ensureDataLayer() {
  if (typeof window === "undefined") return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

function gtagFn(...args) {
  const dl = ensureDataLayer();
  if (!dl) return;
  dl.push(arguments);
}

export function loadStoredConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.state) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function persistConsent(state, choice) {
  if (typeof window === "undefined") return;
  const payload = {
    state,
    choice, // "all" | "none" | "custom"
    version: 1,
    timestamp: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {}
}

export function updateConsent(state, choice = "custom") {
  const dl = ensureDataLayer();
  if (!dl) return;
  // gtag('consent','update', state)
  dl.push(["consent", "update", state]);
  // Custom event so downstream (GTM) can react
  dl.push({ event: "cookie_consent_update", consent_state: state, consent_choice: choice });
  persistConsent(state, choice);
}

export function reapplyStoredConsent() {
  const stored = loadStoredConsent();
  if (!stored) return null;
  const dl = ensureDataLayer();
  if (dl) dl.push(["consent", "update", stored.state]);
  return stored;
}

export function hasStoredConsent() {
  return !!loadStoredConsent();
}

export function clearStoredConsent() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch (_) {}
}
